/** @type {import('next-intl').Config} */
const config = {
    locales: ['en', 'fr', 'es'],
    defaultLocale: 'en',
    // Suppress missing translation errors
    onError(error) {
        // Only log in development, suppress in production
        if (process.env.NODE_ENV === 'development') {
            console.warn('next-intl warning:', error.message);
        }
        // Don't throw - return silently
    }
};

module.exports = config;
